"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intents = void 0;
const lex_constants_data_1 = require("./lex-constants.data");
exports.intents = [
    {
        name: 'cb_iss_mosquito_intent',
        utterances: [
            'When is mosquito spraying going to happen',
            'the mosquitos are getting bad',
            'mosquito control',
            'mosquito',
            'mosquitos',
            'I need someone to spray for mosquitos',
            'mosquitos at {address}',
            'mosquitos on {address}',
            'Mosquito spray',
            'Mosquito spraying',
            'Can I request a mosquito spray'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll report the mosquitos at {address} to the appropriate department now."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Let me summarize this conversation quickly: You've reported mosquitos by {address}. Is that correct?"
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'Thanks for letting me know about the mosquitos. What is your address, so I can report this for you?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        isSRIntent: true,
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true
    },
    {
        name: 'cb_cancel_conversation_intent',
        parentIntentSignature: 'AMAZON.CancelIntent',
        isSRIntent: false,
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot, lex_constants_data_1.LexBotType.SearchAndMessageBot],
        protected: true
    },
    {
        name: 'cb_message_intent',
        utterances: [
            'I want to leave a message about {issue_slot}',
            'I have a message',
            'can I speak to a representative',
            'can I just leave a message',
            'message',
            'mensaje',
            'people are drinking in the street',
            'person',
            'talk to a person',
            'speak to a representative',
            'I want to talk to a person',
            'homeless',
            'homelsesness',
            'I want to send an email',
            'send an email',
            'there is broken glass in the middle of the street'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Thank you, A message for City staff or additional help is Initiated!'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Ok I've got that message ready to send! Would you like me to send it?"
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.FreeFormInput',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'message',
                maxAttempts: 1,
                ellicitedMessage: 'Please enter your message.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'issuetype',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 6,
                name: 'issue_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What is the issue?',
                obfuscationSetting: 'None'
            }
        ],
        isSRIntent: false,
        acceptedBots: [lex_constants_data_1.LexBotType.SearchAndMessageBot, lex_constants_data_1.LexBotType.LegacyBot],
        protected: true
    },
    {
        name: 'cb_missed_recycling_pickup',
        utterances: [
            '{recycling_phrase} out early',
            'Do you offer {recycling_phrase}',
            '{recycling_phrase} pick up',
            'missed {recycling_phrase}',
            '{recycling_phrase} missed',
            'my {recycling_phrase} was missed',
            '{recycling_phrase} pickup',
            'empty my {recycling_phrase} can at {address}',
            'When can someone pick up the {recycling_phrase} in front of my house at {address}',
            "you haven't picked it up in {last_pickup}",
            'please pick up the {recycling_phrase} on my street at {address}',
            'I have {recycling_phrase} to be picked up in front of my house',
            'missed my {recycling_phrase} pickup. I live at i live at {address}',
            'Please pick up my {recycling_phrase} at {address}',
            'I would like to request a {recycling_phrase} pickup',
            'report a missed {recycling_phrase} pickup',
            'report my {recycling_phrase} was not picked up',
            'pick up my {recycling_phrase} at my house',
            'missed {recycling_phrase} collection',
            'no one picked up my {recycling_phrase}',
            'my {recycling_phrase} is still on the curb',
            'my {recycling_phrase} is still sitting outside'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be report recycling pickup at {address}"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Do you want to go ahead and raise request for recycling pickup at {address} ?'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'Please enter the container location',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'ContainerLocation',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'containerLocation',
                maxAttempts: 2,
                ellicitedMessage: 'Please confirm. Is the container located curbside or backyard?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'LocationType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'locationType',
                maxAttempts: 2,
                ellicitedMessage: 'Please confirm by replying with Multi-family location, Single family location or Business location. Please Select one of them',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'ScheduledDay',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 8,
                name: 'scheduledDay',
                maxAttempts: 2,
                ellicitedMessage: 'What day of the week is your scheduled collection day?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.DURATION',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 9,
                name: 'last_pickup',
                maxAttempts: 2,
                ellicitedMessage: 'Also, when is the last time it was picked up?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'recycling_phrase',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 10,
                name: 'recycling_phrase',
                maxAttempts: 2,
                ellicitedMessage: 'n/a',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'ScheduledWeek',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 11,
                name: 'scheduledWeek',
                maxAttempts: 2,
                ellicitedMessage: 'On Which week of the month collection is scheduled?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'intercept_fv_code_violation_inspection',
        utterances: ['code violation'],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the Code violation issue"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the Code violation issue'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: false
    },
    {
        name: 'CitibotListServices',
        utterances: [
            'what can you do',
            'what can you help me with',
            'what types of services do you offer',
            'what do you do',
            'how can you help me',
            'what can Citibot do',
            'how can Citibot help',
            'what do I do',
            'what are some things you can do',
            'what are some things Citibot can do',
            'how can Citibot help me',
            'how can Citibot help my city',
            'how can Citibot help anyone',
            'what is Citibot good for',
            'what is this for',
            'what do I use this for',
            'what do I text you',
            'what are some things you can help me with'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Thank you, How can I help you?'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Hi I am citibot, Is there anything I can help you with?'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: false
    },
    {
        name: 'cb_iss_traffic_intent',
        utterances: [
            'traffic flow',
            'traffic {traffic_issue}',
            'traffic {traffic_issue} due to speed',
            'traffic jam',
            'traffic outside the house'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the traffic {traffic_issue}"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the traffic issue'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'What is the address of the traffic issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'traffic_issue',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'traffic_issue',
                maxAttempts: 2,
                ellicitedMessage: 'What is the issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_covid_vaccine_intent',
        utterances: [
            'Vaccine please',
            'where can i get a vaccine',
            'how do i get a vaccine',
            'how do i get the vaccine',
            'vaccine info',
            'What is the vaccination process like',
            'What should I expect when I arrive at the vaccine site on my appointment date',
            'vaccination',
            'Do I have to be a resident to receive a covid nineteen vaccine',
            'Who is currently eligible for the covid nineteen vaccine',
            'What is my first step to getting a vaccine',
            'I am interested in receiving a covid nineteen vaccine',
            'do I need to register again on the Tarrant County Public Health website',
            'Report Self dash Quarantine',
            'Illegal Eviction Reporting',
            'Request for Test Results',
            'Sanitation Supplies',
            'Business Impact Registry',
            'BTX Cares',
            'COVID dash nineteen',
            'Covid',
            'pruebas',
            'Vaccine',
            'Vaccines',
            'vacunas',
            'PCR',
            'Rapid testing',
            'Vaccine clinic',
            'vaccination clinic',
            'covid'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Here is some information on covid vaccinations'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the Covid Vaccine intent'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: false
    },
    {
        name: 'cb_no_intent',
        utterances: ['no', 'nope', "i don't"],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "No problem. If I'm having trouble understanding the report, you can type the word - message - to start the process of leaving us a message that we can use to follow up."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Are you sure about that?'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: false
    },
    {
        name: 'cb_cancel_fallback_intent',
        utterances: ['exit', 'quit', 'delete', 'erase', 'forget it', 'nevermind'],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "No problem, I've canceled the request. Feel free to let me know if anything else comes up."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Are you sure you want to cancel and start over?'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot, lex_constants_data_1.LexBotType.SearchAndMessageBot],
        protected: true,
        isSRIntent: false
    },
    {
        name: 'cb_search_dispatch_intent',
        utterances: [
            'When is {city_service_slot} on {street_slot}',
            'When is {city_service_slot} at {address_slot}',
            'How do I {action_slot} a {general_loc_slot}',
            'Can I {action_slot} at the {general_loc_slot}',
            'Where can I find info about {city_service_slot}',
            'Where do I go for {city_service_slot}',
            'when is {event_slot}',
            'what is the {city_service_slot} schedule on {street_slot}',
            'when is the next {event_slot}',
            'what is the {city_service_slot} schedule',
            'Where is the {event_slot} tonight',
            'What are the {city_service_slot} hours',
            'When is {city_service_slot} on {event_slot}',
            'is there {city_service_slot} on {event_slot}',
            'is there {city_service_slot} on {day_of_wk_slot}',
            'is there {city_service_slot} today',
            'is there {service_fallback_slot} today',
            'is there {service_fallback_slot} on {event_slot}',
            'is the {service_fallback_slot} going to come today',
            'is the {service_fallback_slot} gonna come on {event_slot}',
            'How do I schedule a {city_service_slot}',
            'How do I schedule an appointment for {city_service_slot}',
            'What is the best way to {action_slot} {city_service_slot}',
            'do I need to {action_slot} for {city_service_slot}',
            'Can I {action_slot} at {general_loc_slot}',
            'What is the {service_fallback_slot} schedule',
            'What can be recycled',
            'What cant be thrown away',
            'How do I {action_slot} a {service_fallback_slot}',
            'How much does {service_fallback_slot} cost',
            'how much does {city_service_slot} cost',
            'I need a {city_service_slot}',
            'I need a {service_fallback_slot}',
            '{city_service_slot} fees',
            '{service_fallback_slot} fees',
            '{license_type} license',
            'who is the building inspector',
            'I need to make a {service_fallback_slot} request',
            'licenses',
            'FOIA',
            'information about {city_service_slot}',
            'information about {service_fallback_slot}',
            'I would like to request a {city_service_slot}',
            'I would like to request a {service_fallback_slot}',
            'permit inspection',
            'What do I do',
            'I lost my {replace_item}',
            'replace a {replace_item}',
            'does {city_name_slot} have {city_service_slot}',
            'does {city_name_slot} have {service_fallback_slot}',
            'where is the {city_service_slot} center',
            'how do I contact {city_service_slot}',
            'search how to',
            'i dont know when my {city_service_slot} is',
            'holiday closings',
            'when are town offices open',
            'I need to know when my {city_service_slot} day is',
            '{city_service_slot} day',
            '{service_fallback_slot} day',
            'What time does {general_loc_slot} close',
            'search',
            'perform a search',
            'what is my {city_service_slot} day',
            'what is my city website',
            'how do i request a {license_type}',
            'street closures',
            'apply for a job',
            'do i have a warrant in {city_name_slot}',
            'what is the address to the {city_name_slot} music hall',
            'Are there any events coming up',
            'where do i go to pickup',
            'how do i request',
            'what are my {service_fallback_slot}',
            'What job opportunities are there with the city',
            'can you help me with housing',
            'outdoor pool',
            'how can I pay my water bill',
            'What business are coming into town',
            'Do you have any idea when trash bulk pickup will return',
            'When will trash and bulk pickup resume',
            'what are the park hours',
            'what time is mansel park open',
            'how do i register to vote',
            'water bill options',
            'recycling center',
            'exempt from trash service',
            'how to recycle paint',
            'median income',
            'who is the mayor',
            'population',
            'recycle center',
            'are we getting a {business_slot}',
            'when is {business_slot} going to open',
            'Is there fluoride in my water',
            'What is my water pressure',
            'How can I test for a leak',
            'When and how does my meter get read',
            'Can I drain my pool into the sewer system',
            'Do I need a permit to drain my pool',
            'Do I get a break on my water bill when filling my pool',
            'How do I know what my last meter reading was',
            'Where does my water come from',
            'Is my water safe',
            'How can I help reduce the mosquito population in Queen Creek',
            'how to make a payment',
            'make a payment',
            'how do i make a payment',
            'city council',
            'Who is the {city_name_slot} city manager',
            'covid nineteen',
            'Whats up with covid',
            'What is the city doing about covid',
            'when is covid nineteen going to end',
            'information about covid nineteen',
            'coronavirus',
            'novel coronavirus',
            'what is the city doing about coronavirus',
            'city manager',
            'who is the city manager',
            'phase four guidelines',
            'What time does the splash pad open tomorrow',
            'What time does the splash pad open',
            'Where can I pay my water bill',
            'social distancing',
            'social',
            'mask',
            'masks',
            'what are the mask regulations',
            'where ya at',
            'do i have to wear a mask',
            'how do i order a new trash bin',
            'how do i order a new trash can',
            'how do i order a new trash cart',
            'I have a lot of crime in my neighborhood. What can I do about it',
            'what can I do about crime in my neighborhood',
            'what should I do about crime',
            'When will we see justice for Elijah McClain',
            'How do I find out what they are building at Peoria and Iliff',
            'what are they building at peoria and lliff',
            'what are they building',
            'Do I need to show up before my appointment',
            'fire ban',
            'adopt a pet',
            'is it flooding',
            'Is mardi gras happening',
            'can i recycle glass',
            'what can i recycle',
            'Can I sign up for covid meals',
            'How many people can be indoor at the same time',
            'What are the rules on gatherings',
            'how many people can we have in a group',
            'is outdoor dining allowed',
            'what is three one one',
            'meal assistance',
            'how do i get meal assistance',
            'I need meal assistance',
            'can i sign up for meal assistance',
            'Can you help me find the sanitation schedule',
            'service cut',
            'my water was cut off',
            'my water service has been cut off',
            'I have no water',
            'I dont have water',
            'who is my council member',
            'Who are my council members',
            'Allison Ave Construction',
            'College Dr Construction',
            'University Ave Construction',
            'sixtey ninth St Construction',
            'I want to plant a tree',
            'I want to plant a flower bed',
            'How can I plant a tree',
            'where can I plant a tree',
            'where can I grow a flower bed',
            'I want to grow a flower bed',
            'Business Renewal',
            'hotel',
            'motel',
            'Short term rental',
            'Hard Rock Hotel',
            'Spring clean up event',
            'Tax question',
            'Pay property tax',
            'pay Pay property tax',
            'Personal property tax question',
            'school bus',
            'unpermitted work in row',
            'brush piles',
            'brush pickup',
            'When is my brush pile going to be picked up',
            'Parks Activating Summer Programs',
            'fourth of july',
            'fourth of july celebration',
            'when is the fourth of july celebration',
            'Where can I drop off recycling',
            'Del Mar Aquatic Center',
            'Del Mar Family Aquatic Center',
            'Meadow Hills',
            'Meadow Hills Swimming Pool',
            'Aqua Vista',
            'Aqua Vista Swimming Pool',
            'Pheasant Run',
            'Village Green',
            'Parklane',
            'when do the pools open',
            'Park shelter rentals',
            'Shelter rentals',
            'Park rentals',
            'Reserve a park shelter',
            'Does Aurora provide free tree branch removal due to snow storms',
            'Register a bicycle online',
            'Identity theft',
            'Pay my bill',
            'Pay tickets online',
            'animal shelter',
            'How do I find out if Washington County has any job openings',
            'Pay taxes',
            'How do I pay my taxes',
            'assessor',
            'Assess',
            'livestock',
            'trailer',
            'tags',
            'car tags',
            'renew my license',
            'renew',
            'renew a business license',
            'Situs',
            'pet',
            'Circuit Clerk',
            'fines',
            'deed',
            'leins',
            'drug',
            'taxes',
            'collector',
            'tax collector',
            'county clerk',
            'DBA',
            'voting registration',
            'voter registration',
            'voting',
            'election',
            'when is the election',
            'election commission',
            'dem',
            'where is the dump',
            'dump',
            'juvenile detention',
            'parcel',
            'parcel of land',
            'Prosecuting',
            'bidding',
            'veterans',
            'vet',
            'benifits',
            'benefits',
            'veteran benefits',
            'vet benefits',
            'who is the sheriffs deputy',
            'deputy',
            'veteran services',
            'sheriff',
            'can I surrender an animal to you',
            'can I adopt an animal from you',
            'what is the homestead property tax credit',
            'homestead property tax credit',
            'what are the requirements for the homestead tax credit',
            'The property taxes on my home are three hundred fifty dollars will the state send me twenty five dollars so I get the full credit',
            'How can I check the status of my request',
            'Need water service',
            'How do I contest a ticket',
            'how can i avoid getting a ticket',
            'how do i pay a ticket online',
            'how do i fight a ticket',
            'what permits are offered as permit by plate',
            'what permits are offered',
            'who is eligible for permit by plate visitor permits',
            'what are my options if I dont want permit by plate',
            'what if i need a visitor permit immediately',
            'how do i register for a residential parking permit account',
            'how do i request a visitor permit if i have an active permit',
            'what is the cost of a visitor permit',
            'how many permits may i request',
            'how long is a permit valid',
            'How many vehicles may be assigned to a permit at one time',
            'does everyone need a parking permit',
            'can I use my permit throughout the city',
            'where should my guest park',
            'what should my guests know when visiting',
            'how mush does a parking permit cost',
            'what are permit fees used for',
            'may i get more than one permit if i have multiple vehicles',
            'i have a permit but cant find a parking space',
            'may i purchase permits if i have parking tickets',
            'where do i place the decal',
            'where do i place my permit',
            'who decides what the parking regulations are',
            'what if i get a ticket even though i have a valid permit',
            'does my permit exempt me from street sweeping',
            'What does MSBU mean',
            'Can you tell me about MSBU',
            'I need information on MSBU',
            'I need a HIPAA release form',
            'How do I get a HIPAA release form',
            'Find a map of clay county',
            'find a map of the county',
            'interactive map of clay county',
            'How much is it to rent a cabin at camp chownewaw park',
            'How much does it cost to go to camp chowenwaw',
            'fee for swimming at camp chownewaw park',
            'renting a campsite at camp chow',
            'does camp chowenwaw park have rv parking',
            'What is available in the Orange Blossom room at camp chowenwaw',
            'What can I do to fix my credit',
            'Does mosquito control harm bees',
            'why did my contractor license get put on hold',
            'what is going on with my va claim',
            'what VA benefits am I eligible for',
            'how do i get transportation to the va medical center',
            'Where are bcc awarded bids listed',
            'what parks allow dogs',
            'When will my road by graded',
            'How do I get gravel added to my county road',
            'Who do I contact with concerns about speeding on a county road',
            'Does the road department remove dead animals from the county road or right-of-way',
            'can you make my neighbor stop shooting guns',
            'How do I resolve a property line dispute with my neighbor',
            'How do I get a copy of a police report',
            'How do I add information to a police report',
            'Can I file a police report online',
            'Who do I contact with questions abut subpoenas or summons',
            'Can you help get my property back',
            'How do I get a restraining order',
            'how do i get a protection order',
            'How can I check if a restraining order has been served',
            'Where to I got to get traps for stray animals',
            'Who do i contact to find out how much a bond is',
            'Who do i contact about property seizures',
            'How can I get a background check on someone',
            'How can I find out if a sex offender lives near me',
            'Where is the sex offenders registry',
            'When is my child required to wear a car seat',
            'How do I get a copy of my driving record',
            'How can I file a complaint against an employee',
            'Is there a noise ordinance',
            'Can the police jump start my car',
            'How can I report child abuse',
            'How can I report elder abuse',
            'Do i need a helmet to ride a moped',
            'Can I set off fireworks in the county',
            'How do i report a vicious animal',
            'What do i do if im bitten by a dog',
            'What do i do if im bitten by a cat',
            'What if a dog bit someone at my house',
            'How do a appeal a dog declared hazardous',
            'How do I obtain a fire report',
            'How to i get a free smoke alarm',
            'what is illegal to burn',
            'What do I do with a house after it has been burned',
            'What permits do I need for a large scale development',
            'What permits do I need for a subdivision',
            'What is the zoning for my property',
            'What is the phone number for commissary',
            'Can I call to talk to a detainee',
            'When do you fingerprint for the public',
            'How much does it cost to be fingerprinted',
            'When will a detainee be transported to prison',
            'Can I pick up a detainees property',
            'How long does it take for a warrant to be processed',
            'How do I qualify for a public defender',
            'Do you have low clerk positions or internship opportunities',
            'Do you have low clerk positions or internship jobs',
            'What is a subpoena',
            'What happens after I file a complaint',
            'What is an affidavit',
            'What is an information',
            'When is a non support claim a felony',
            'How can I correct my acreage on an assessment',
            'What is a reappraisal',
            'Is it possible to have to parcels of land combined',
            'How is a reappraisal done',
            'When do reappraisals oocur',
            'May i add a vehicle over the phone',
            'where does my tax money go',
            'What is the difference between personal property and real estate',
            'Do you have an interactive map viewer',
            'How can I verify an address for a building',
            'why did i get a code violation',
            'why am I being cited for not having a permit on a property I just purchased',
            'How long will it take for the Code Enforcement officer to respond to my complaint',
            'How long will it take to resolve the code enforcement violation',
            'What will Code Enforcement do if I refuse to comply with the County Code',
            'Can I remain anonymous when filing a complaint',
            'How can I get landscaping questions answered',
            'How long is food good in a refrigerator without power',
            'How can I improve my credit score and clean up my credit history',
            'How can I turn my land into a farm',
            'How do I join four dash H',
            'When is spraying scheduled for my neighborhood',
            'Can I get sick from a mosquito bite',
            'Where are all the mosquitoes coming from',
            'Do all mosquitoes bite',
            'How many types of mosquitoes are there',
            'Do you provide public education about mosquitoes',
            'How many phone calls do you need to spray in my area',
            'Do you have a set schedule for spraying mosquitoes',
            'why is this land being cleared out',
            'how do i find out if a lot is buildable',
            'What are my setbacks on my property',
            'how long is plan review',
            'Do you help Veterans with rent or utility bills',
            'Do you provide transportation to the VA Medical Center in Gainesville or Lake City',
            'Where do I get a VA ID card',
            'where can i find bccs recent bids',
            'Where do I dispose of tires',
            'where can I throw out furniture',
            'how do I dispose of hazardous waste',
            'Where do I dispose of appliances',
            'Who can I contact to remove large appliances',
            'Where can I launch my boat in Clay County',
            'Where can I find a list of pet friendly parks',
            'Do you have horses available for adoption',
            'What can I do with this dog that I found',
            'where can I find lost pets',
            'How can I find out what issues are on the BCC Agenda',
            'How can I get a copy of the video or audio tape of the BCC meetings',
            'Can I give a PowerPoint Presentation during Public Comments',
            'I am having a sewage problem',
            'When will my road be resurfaced',
            'How do I sign up to receive emergency notifications',
            'Where can I get flood insurance',
            'what to bring to camp chowenwaw park for camping',
            'What is there to do at Camp Chowenwaw Park',
            'central city senior center',
            'oxygen exchange sites',
            'oxygen exchange',
            'charging stations',
            'recharge my phone',
            'where can i charge my phone',
            'where can i charge my device',
            'is there somewhere i can charge',
            'What permits are offered as Permit-by-Plate',
            'Who is eligible for Permit-by Plate Visitor Permits',
            'What are my options if I would rather not use Permit-by-Plate',
            'What if I only need Visitor Permits',
            'How long does it take for a Permit-by-Plate application to be approved',
            'What if I need a Visitor permit immediately',
            'How do I register for a Residential Parking Permit account in order to obtain Visitor Permits through the Permit-by-Plate system',
            'How do I request visitor permits if I already have an active Residential Parking Permit account',
            'What is the cost to request Visitor permits',
            'How much does a visitor permit cost',
            'How many permits may be requested',
            'How long is a permit valid',
            'How many vehicles may be assigned to a permit at a single time',
            'May parking Permits be Reused',
            'How will Parking Enforcement know I have a permit if I dont have a physical permit displayed',
            'How do I resize my PDF or other documents',
            'Who decides what areas become permit parking',
            'Does everyone need a parking permit',
            'How do I obtain a parking permit',
            'Can I use my permit throughout the city',
            'May I share my permit with another motorist',
            'May I share my permit between vehicles',
            'Where should my guests park',
            'What should my guests know when visiting during hours in which permit parking regulations are enforced',
            'How much does a parking permit cost',
            'What are parking permit fees used for',
            'May I get more than one permit if I have more than one vehicle',
            'Where may I obtain a Visitor Permit',
            'I have a permit and cant find a parking space',
            'May I purchase parking permits if I have parking tickets',
            'Where does the Resident Decal Permit get placed',
            'Who decides what the parking regulations will be',
            'What if I get a ticket even though I had a valid parking permit',
            'Does my parking permit exempt me from street sweeping restrictions',
            'When is trick or treating in Opelika',
            'trick or treat',
            'trick or treating',
            "Why doesn't the City install a stop sign at a certain intersection",
            'How do I ask the City to review a traffic problem in my neighborhood',
            'What can be done about speeding in my neighborhood',
            "My neighbor's dog dug up my flowers can it be declared hazardous",
            'Can I go on a police ride a long',
            'What job opportunities are currently available',
            'Can you help me get my property back from my old roommate husband or wife',
            'If I turn myself in for a warrant or commitment how long will it take to be processed',
            'What is the maximum income I can have in order to qualify for a public defender',
            'How can I verify information about a current or past employee',
            'What can I do to my home to prevent flooding',
            'Fairfield by Marriott',
            'What Radio and TV channels should I use to track emergency watches and warnings',
            'Do you have any information on flood safety',
            'show my property value',
            'Who is responsible for cleaning after an event at the clay county fairground',
            'Do I have to pay in full before my event at the clay county fairground',
            'What flood zone am I located in',
            'What Hotels are in Clay County',
            'List of hotels in Clay County',
            'What is wrong with my pond',
            'What hotels are in Fleming Island',
            'How do I pay a ticket',
            'How do I pay a ticket online',
            'can I share my permit with another vehicle',
            'can permits be reused',
            'can parking permits be reused',
            'How do I get prescription medications to my child',
            'What does the Election Commission do',
            'When are my taxes due',
            'What does the Circuit Clerk do',
            'How do I report damage done to a county bridge guard rail',
            'Do I need a permit if I have a disabled persons placard issued by the DMV',
            'May Permits be Reused',
            'How old do I have to be to get married',
            'How can I get a tax receipt',
            'What places offer Veteran discounts',
            'How do I submit a bid',
            'How do I submit a proposal',
            'elevate course',
            'Elevate',
            'Apex Peakway',
            'Peakway',
            'Apex Peakway projects',
            'Peakway projects',
            'Sculpture walk',
            'Stormwater Utility Fee',
            'Stormwater Fee',
            'Impervious Surface Fee',
            'Impervious Fee',
            "Where can I find past year's budgets",
            'What is a JP',
            'who is my JP',
            'who is my Justice of the Peace',
            'I need a copy of my divorce.',
            'master plan',
            'mater plan',
            'Recycling Drop off Facilities',
            'special waste',
            'Death Records',
            'List of all County locations',
            'turkey trot',
            'turkey',
            'Im looking for disabled parking information',
            'Disabled parking',
            'the drop',
            'parking credits',
            'parking locations',
            'citations',
            'ev charging',
            'parking location',
            'Bonner Lot',
            'Robo dash garage',
            'Robo garage',
            'Automated Garage',
            'Robertson Lot',
            'EV charging',
            'make an appointment',
            'Make an appointment',
            'low income payment plans',
            'My car was towed from private property',
            'are meters enforced on holidays',
            'are meters enforced during the holidays',
            'street cleaning maps',
            'How much does a resident parking permit cost',
            'oversize vehicle',
            'parking encroachment',
            'preferential parking',
            'parking meter operating hours',
            'credit card parking meters',
            'parking services staff',
            'Is it free',
            'Is there a set schedule',
            'Do I have to come at the same time every day',
            'How soon could I graduate',
            'Do I have to take the GED practice test before I can test for real',
            'Can I take the GED if Im still in high school',
            'If I get my GED can I go back to walk with my class',
            'Do I have to start over',
            'Can you use my old credits',
            'Can you use my previous credits',
            'Do I need to bring my transcript',
            'Can you authenticate my foreign diploma',
            'Will these classes work for my visa',
            'Am I enrolled in school for my F dash one',
            'Can DACA students get a letter showing Im enrolled in classes',
            'Can Parolees get a letter showing Im enrolled in classes',
            'power outage',
            'no power',
            'surge',
            'power surge',
            'flickering light',
            'no electricity',
            'Bluegrass',
            'Bluegrass on Ballard',
            'Storytime',
            'Water Bill',
            'X-treme Green',
            'Xtreme Green',
            'Accident Report',
            'Pedal Car Race',
            'Study Rooms',
            'Dog Vaccination',
            'I need a job',
            'How much is the tuition',
            'Why do I have to take a test',
            'What am I going to be tested on',
            'Do I have to take the GED Ready a practice test before I can test for real',
            'Can I take the GED if I am still in high school',
            'I took my GED prior to two zero one four Do I have to start over',
            'Can I use college credit experience toward my diploma',
            'Can you verify my foreign diploma',
            'Will these classes work for my visa Am I enrolled in school for my F one',
            'Can DACA students get a letter showing I am enrolled in classes',
            'Can Parolees get a letter showing I am enrolled in classes',
            'How is my SSN used',
            'Why do you want my SSN',
            'What is the difference between a GED and a high school diploma',
            'Can you use credits from my country',
            'My class has not graduated yet What do I need to do to take the GED',
            'I am one seven and want to take the GED What do I have to do',
            'I am one six and want to take the GED What do I have to do',
            'What is the phone number for Parking Services',
            'phone number for parking service',
            'when is trash picked up day',
            'when is trash picked up',
            'what day is trash pickup',
            'Special needs registry',
            'smart nine one one sign up',
            'Clean up',
            'spring cleaning',
            'Homeless',
            'Homelessness',
            'Homeless safety',
            'Homeless encampment',
            'There is a homeless encampment on {street_slot}',
            'There is a homeless encampment at {street_slot}',
            'Water conservation',
            'I need a new garbage can',
            'I need a new garbage bin',
            'I need a new garbage container',
            'I need a new recycling can',
            'I need a new recycling bin',
            'I need a new recycling container',
            'I need a new litter can',
            'I need a new litter bin',
            'I need a new litter container',
            'I need a new trash can',
            'I need a new trash bin',
            'I need a new trash container',
            'someone stole my trash can',
            'someone stole my trash bin',
            'someone stole my trash container',
            'someone stole my recycling can',
            'someone stole my recycling bin',
            'someone stole my recycling container',
            'someone stole my garbage can',
            'someone stole my garbage bin',
            'someone stole my garbage container',
            'someone stole my litter can',
            'someone stole my litter bin',
            'someone stole my litter container',
            'they forgot to pick up my trash',
            'they forgot to pick up my recycling',
            'they forgot to pick up my garbage',
            'Missed trash pickup',
            'missed garbage pickup',
            'missed recycling pickup',
            'I want to contact the mayo',
            'I need to speak to the mayor',
            'Can I contact the mayor',
            'Can I speak to the mayor',
            'I want to contact the city administrator',
            'I need to speak to the city administrator',
            'Can I contact the city administrator',
            'Can I speak to the city administrator'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Let me quickly search for that on county information services for you. One moment please.'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Are you sure to continue with the search intent?'
                }
            ]
        },
        slots: [
            {
                slotType: 'cb_search_action_slot',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 1,
                name: 'action_slot',
                maxAttempts: 2,
                ellicitedMessage: "What is the activity you're looking for?",
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 2,
                name: 'address_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What is the address you nee need {city_service_slot} at?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.LocalBusiness',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 3,
                name: 'business_slot',
                maxAttempts: 2,
                ellicitedMessage: "What's the name of the establishment this is by?",
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.US_CITY',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 4,
                name: 'city_name_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What is the name of the city?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.Service',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 5,
                name: 'city_service_slot',
                maxAttempts: 2,
                ellicitedMessage: "What is the specific question or information you're searching for? You can also type 'leave a message' to leave us more information.",
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.DayOfWeek',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 6,
                name: 'day_of_wk_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What day?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.EventType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 7,
                name: 'event_slot',
                maxAttempts: 2,
                ellicitedMessage: "What is the specific event you're looking for?",
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.CivicStructure',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 8,
                name: 'general_loc_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What is the general location?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'cb_license_service_type_slot',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 9,
                name: 'license_type',
                maxAttempts: 2,
                ellicitedMessage: 'What kind of license is it?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'cb_search_replace_item_slot',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 10,
                name: 'replace_item',
                maxAttempts: 2,
                ellicitedMessage: 'What kind of item are you looking for?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'cb_search_service_fallback_slot',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 11,
                name: 'service_fallback_slot',
                maxAttempts: 2,
                ellicitedMessage: "What is the service you're looking for?",
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.StreetAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 12,
                name: 'street_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What is the name of the street you live on?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot, lex_constants_data_1.LexBotType.SearchAndMessageBot],
        protected: true,
        isSRIntent: false
    },
    {
        name: 'FW_cave_in_intent',
        utterances: [
            '{cave_in_phrase}',
            '{issueOpening} {cave_in_phrase}',
            '{issueOpening} {cave_in_phrase} {proximity} {address}',
            '{issueOpening} {cave_in_phrase} {proximity} {streetNameOne}',
            '{issueOpening} {cave_in_phrase} {proximity} {streetNameOne} and {streetNameTwo}',
            '{cave_in_phrase} {proximity} {address}',
            '{cave_in_phrase} {proximity} {proximityDesc} {address}',
            '{cave_in_phrase} {proximity} {proximityDesc} {streetNameOne}',
            '{cave_in_phrase} {proximity} {proximityDesc} {streetNameOne} and {streetNameTwo}',
            'the street is {cave_in_phrase}',
            'there is a big hole in the street',
            'there is a big hole in my neighborhood',
            'street subsidence',
            'street sbusidance',
            'street subsidance',
            'street sinking',
            'road sinking',
            'road subsidance',
            'road subsidence'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the Cave in issue"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the Cave in issue'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'What is the address where the cave-in is?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'FW_cave_in_phrase',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'cave_in_phrase',
                maxAttempts: 2,
                ellicitedMessage: 'what is the issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.NUMBER',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 8,
                name: 'feet_deep',
                maxAttempts: 2,
                ellicitedMessage: 'how deep is the cave-in?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.NUMBER',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 9,
                name: 'feet_wide',
                maxAttempts: 2,
                ellicitedMessage: 'About how wide is the cave-in?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'IssueOpening',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 7,
                name: 'issueOpening',
                maxAttempts: 2,
                ellicitedMessage: "What's the issue?",
                obfuscationSetting: 'None'
            },
            {
                slotType: 'Proximity',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 8,
                name: 'proximity',
                maxAttempts: 2,
                ellicitedMessage: 'Where is the issue?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'ProximityDescription',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 9,
                name: 'proximityDesc',
                maxAttempts: 2,
                ellicitedMessage: 'Where is the issue?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 5,
                name: 'streetNameOne',
                maxAttempts: 2,
                ellicitedMessage: 'What street is the cave-in on?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 6,
                name: 'streetNameTwo',
                maxAttempts: 2,
                ellicitedMessage: 'What is the nearest cross street?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_no_email',
        utterances: [
            "I don't have an email address",
            "I don't want to provide my email",
            "I don't want to give my email",
            'no email',
            "I don't have one"
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Thank you, For your information!'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Are you sure you do not have any email?'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: false
    },
    {
        name: 'cb_illegal_dumping_intent',
        utterances: [
            'illegal dumping',
            'there is illegal dumping on the neutral ground',
            'someone is dumping illegally',
            'someone has illegally dumped',
            'illegal dumping on the neutral ground',
            'illegal dumping in the median',
            'there is trash in the median',
            'there is trash on the neutral ground',
            'dumping in the median',
            'dumping on the neutral ground',
            'Furniture Dumping'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the illegal dumping issue"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the illegal dumping issue'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'What is the address?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'citibot_yes_no',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'isPrivateProperty',
                maxAttempts: 2,
                ellicitedMessage: 'Is this located on private property?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'PropertyStatus',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'propertyStatues',
                maxAttempts: 2,
                ellicitedMessage: 'Is this property vacant or occupied?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'citibot_yes_no',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 8,
                name: 'tenantConfirmation',
                maxAttempts: 2,
                ellicitedMessage: 'Please answer Yes or No. Are you a tenant?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_cache_get_recycling_bin_intent',
        utterances: [
            'How can I get a {recycling_phrase} bin',
            'I need a new {recycling_phrase} bin',
            'request new {recycling_phrase} bin',
            'how do I get a new {recycling_phrase} bin',
            'my {recycling_phrase} bin is broken',
            '{recycling_phrase}',
            'requesting new {recycling_phrase} container',
            '{recycling_phrase} is broken on {address}',
            'I need a {recycling_phrase} at {address}',
            'i need a {recycling_phrase} on {address}'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'We have submitted your request to obtain a {recycling_phrase} container at {address}'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to obtain a {recycling_phrase} container at {address}'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'What is the address?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'ContainerLocation',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'containerLocation',
                maxAttempts: 2,
                ellicitedMessage: 'Please confirm. Is the container located curbside or backyard?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'citibot_yes_no',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'curbsideConfirmation',
                maxAttempts: 2,
                ellicitedMessage: 'Please answer Yes or No. Is the container located curbside?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'DamageDescribe',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 8,
                name: 'damageDescribe',
                maxAttempts: 2,
                ellicitedMessage: 'Please describe the damage.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.LocalBusiness',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 9,
                name: 'location',
                maxAttempts: 2,
                ellicitedMessage: 'Where is the issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'LocationType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 10,
                name: 'locationType',
                maxAttempts: 2,
                ellicitedMessage: 'Please confirm by replying with the letter A, B, or C. Is this a:',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'recycling_phrase',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 11,
                name: 'recycling_phrase',
                maxAttempts: 2,
                ellicitedMessage: 'What is the recycling issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'replacement_reason',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 12,
                name: 'replacement_reason',
                maxAttempts: 2,
                ellicitedMessage: 'What is the reason for replacement?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'ReplacementConfirmation',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 13,
                name: 'replacementConfirmation',
                maxAttempts: 2,
                ellicitedMessage: 'What is the reason for replacement (ie. Damaged, Stolen)?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_iss_public_property_intent',
        utterances: [
            '{damageType} {propertyType} {proximity} {address}',
            '{damageType} {propertyType} {proximity} {usersResidence}',
            '{damageType} {propertyType} {proximity} {streetNameOne}',
            '{damageType} {propertyType} {proximity} {streetNameOne} and {streetNameTwo}',
            '{damageType} {propertyType} {proximity} {proximityDescription} {address}',
            '{damageType} {propertyType} {proximity} {proximityDescription} {usersResidence}',
            '{damageType} {propertyType} {proximity} {proximityDescription} {streetNameOne}',
            '{damageType} {propertyType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo}',
            '{damageType} {propertyType} {issueClosing}',
            '{damageType} {propertyType} {proximity} {address} {issueClosing}',
            '{damageType} {propertyType} {proximity} {usersResidence} {issueClosing}',
            '{damageType} {propertyType} {proximity} {streetNameOne} {issueClosing}',
            '{damageType} {propertyType} {proximity} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{damageType} {propertyType} {proximity} {proximityDescription} {address} {issueClosing}',
            '{damageType} {propertyType} {proximity} {proximityDescription} {usersResidence} {issueClosing}',
            '{damageType} {propertyType} {proximity} {proximityDescription} {streetNameOne} {issueClosing}',
            '{damageType} {propertyType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{issueOpening}  {propertyType}',
            '{issueOpening}  {propertyType} {proximity} {usersResidence}',
            '{issueOpening}  {propertyType} {proximity} {address}',
            '{issueOpening}  {propertyType} {proximity} {streetNameOne}',
            '{issueOpening}  {propertyType} {proximity} {streetNameOne} and {streetNameTwo}',
            '{issueOpening}  {propertyType} {proximity} {proximityDescription} {usersResidence}',
            '{issueOpening}  {propertyType} {proximity} {proximityDescription} {address}',
            '{issueOpening}  {propertyType} {proximity} {proximityDescription} {streetNameOne}',
            '{issueOpening}  {propertyType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo}',
            '{issueOpening}  {propertyType} {issueClosing}',
            '{issueOpening}  {propertyType} {proximity} {usersResidence} {issueClosing}',
            '{issueOpening}  {propertyType} {proximity} {address} {issueClosing}',
            '{issueOpening}  {propertyType} {proximity} {streetNameOne} {issueClosing}',
            '{issueOpening}  {propertyType} {proximity} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{issueOpening}  {propertyType} {proximity} {proximityDescription} {usersResidence} {issueClosing}',
            '{issueOpening}  {propertyType} {proximity} {proximityDescription} {address} {issueClosing}',
            '{issueOpening}  {propertyType} {proximity} {proximityDescription} {streetNameOne} {issueClosing}',
            '{issueOpening}  {propertyType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{proximity} {address} {issueOpening}  {propertyType}',
            '{proximity} {usersResidence} {issueOpening}  {propertyType}',
            '{proximity} {streetNameOne} {issueOpening}  {propertyType}',
            '{proximity} {streetNameOne} and {streetNameTwo} {issueOpening}  {propertyType}',
            '{proximity} {proximityDescription} {address} {issueOpening}  {propertyType}',
            '{proximity} {proximityDescription} {usersResidence} {issueOpening}  {propertyType}',
            '{proximity} {proximityDescription} {streetNameOne} {issueOpening}  {propertyType}',
            '{proximity} {proximityDescription} {streetNameOne} and {streetNameTwo} {issueOpening}  {propertyType}',
            '{proximity} {address} {issueOpening}  {propertyType} {issueClosing}',
            '{proximity} {usersResidence} {issueOpening}  {propertyType} {issueClosing}',
            '{proximity} {streetNameOne} {issueOpening}  {propertyType} {issueClosing}',
            '{proximity} {streetNameOne} and {streetNameTwo} {issueOpening}  {propertyType} {issueClosing}',
            '{proximity} {proximityDescription} {address} {issueOpening}  {propertyType} {issueClosing}',
            '{proximity} {proximityDescription} {usersResidence} {issueOpening}  {propertyType} {issueClosing}',
            '{proximity} {proximityDescription} {streetNameOne} {issueOpening}  {propertyType} {issueClosing}',
            '{proximity} {proximityDescription} {streetNameOne} and {streetNameTwo} {issueOpening}  {propertyType} {issueClosing}',
            '{propertyType} {proximity} {address} is {damageType}',
            '{propertyType} {proximity} {usersResidence} is {damageType}',
            '{propertyType} {proximity} {streetNameOne} is {damageType}',
            '{propertyType} {proximity} {streetNameOne} and {streetNameTwo} is {damageType}',
            '{propertyType} {proximityDescription} {proximity} {address} is {damageType}',
            '{propertyType} {proximityDescription} {proximity} {usersResidence} is {damageType}',
            '{propertyType} {proximityDescription} {proximity} {streetNameOne} is {damageType}',
            '{propertyType} {proximityDescription} {proximity} {streetNameOne} and {streetNameTwo} is {damageType}',
            '{propertyType} is {damageType}',
            '{propertyType} is  {proximity} {address}',
            '{propertyType} is  {proximity} {usersResidence}',
            '{propertyType} is  {proximity} {streetNameOne}',
            '{propertyType} is  {proximity} {streetNameOne} and {streetNameTwo}',
            '{propertyType} is  {proximity} {proximityDescription} {address}',
            '{propertyType} is  {proximity} {proximityDescription} {usersResidence}',
            '{propertyType} is  {proximity} {proximityDescription} {streetNameOne}',
            '{propertyType} is  {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo}',
            '{address} has a  {propertyType}',
            '{usersResidence} has a  {propertyType}',
            '{streetNameOne} has a  {propertyType}',
            '{streetNameOne} and {streetNameTwo} has a  {propertyType}',
            '{issueOpening} {propertyType} {proximity} {address} is {damageType}',
            '{issueOpening} {propertyType} {proximity} {usersResidence} is {damageType}',
            '{issueOpening} {propertyType} {proximity} {streetNameOne} is {damageType}',
            '{issueOpening} {propertyType} {proximity} {streetNameOne} and {streetNameTwo} is {damageType}',
            '{issueOpening} {propertyType} {proximity} {proximityDescription} {address} is {damageType}',
            '{issueOpening} {propertyType} {proximity} {proximityDescription} {usersResidence} is {damageType}',
            '{issueOpening} {propertyType} {proximity} {proximityDescription} {streetNameOne} is {damageType}',
            '{issueOpening} {propertyType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo} is {damageType}',
            '{issueOpening} {damageAdjective} {issueType}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {address}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {usersResidence}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {streetNameOne}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {streetNameOne} and {streetNameTwo}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {proximityDescription} {address}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {proximityDescription} {usersResidence}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {proximityDescription} {streetNameOne}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo}',
            '{issueOpening} {damageAdjective} {issueType} {issueClosing}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {address} {issueClosing}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {usersResidence} {issueClosing}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {streetNameOne} {issueClosing}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {proximityDescription} {address} {issueClosing}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {proximityDescription} {usersResidence} {issueClosing}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {proximityDescription} {streetNameOne} {issueClosing}',
            '{issueOpening} {damageAdjective} {issueType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{issueType} {proximity} {address}',
            '{issueType} {proximity} {usersResidence}',
            '{issueType} {proximity} {streetNameOne}',
            '{issueType} {proximity} {streetNameOne} and {streetNameTwo}',
            '{issueType} {proximity} {proximityDescription} {address}',
            '{issueType} {proximity} {proximityDescription} {usersResidence}',
            '{issueType} {proximity} {proximityDescription} {streetNameOne}',
            '{issueType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo}',
            '{issueType} {issueClosing}',
            '{issueType} {proximity} {address} {issueClosing}',
            '{issueType} {proximity} {usersResidence} {issueClosing}',
            '{issueType} {proximity} {streetNameOne} {issueClosing}',
            '{issueType} {proximity} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{issueType} {proximity} {proximityDescription} {address} {issueClosing}',
            '{issueType} {proximity} {proximityDescription} {usersResidence} {issueClosing}',
            '{issueType} {proximity} {proximityDescription} {streetNameOne} {issueClosing}',
            '{issueType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{issueOpening} {issueType}',
            '{issueOpening} {issueType} {proximity} {address}',
            '{issueOpening} {issueType} {proximity} {usersResidence}',
            '{issueOpening} {issueType} {proximity} {streetNameOne}',
            '{issueOpening} {issueType} {proximity} {streetNameOne} and {streetNameTwo}',
            '{issueOpening} {issueType} {proximity} {proximityDescription} {address}',
            '{issueOpening} {issueType} {proximity} {proximityDescription} {usersResidence}',
            '{issueOpening} {issueType} {proximity} {proximityDescription} {streetNameOne}',
            '{issueOpening} {issueType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo}',
            '{issueOpening} {issueType} {issueClosing}',
            '{issueOpening} {issueType} {proximity} {address} {issueClosing}',
            '{issueOpening} {issueType} {proximity} {usersResidence} {issueClosing}',
            '{issueOpening} {issueType} {proximity} {streetNameOne} {issueClosing}',
            '{issueOpening} {issueType} {proximity} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{issueOpening} {issueType} {proximity} {proximityDescription} {address} {issueClosing}',
            '{issueOpening} {issueType} {proximity} {proximityDescription} {usersResidence} {issueClosing}',
            '{issueOpening} {issueType} {proximity} {proximityDescription} {streetNameOne} {issueClosing}',
            '{issueOpening} {issueType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{damageAdjective} {issueType}',
            '{damageAdjective} {issueType} {proximity} {address}',
            '{damageAdjective} {issueType} {proximity} {usersResidence}',
            '{damageAdjective} {issueType} {proximity} {streetNameOne}',
            '{damageAdjective} {issueType} {proximity} {streetNameOne} and {streetNameTwo}',
            '{damageAdjective} {issueType} {proximity} {proximityDescription} {address}',
            '{damageAdjective} {issueType} {proximity} {proximityDescription} {usersResidence}',
            '{damageAdjective} {issueType} {proximity} {proximityDescription} {streetNameOne}',
            '{damageAdjective} {issueType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo}',
            '{damageAdjective} {issueType} {issueClosing}',
            '{damageAdjective} {issueType} {proximity} {address} {issueClosing}',
            '{damageAdjective} {issueType} {proximity} {usersResidence} {issueClosing}',
            '{damageAdjective} {issueType} {proximity} {streetNameOne} {issueClosing}',
            '{damageAdjective} {issueType} {proximity} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{damageAdjective} {issueType} {proximity} {proximityDescription} {address} {issueClosing}',
            '{damageAdjective} {issueType} {proximity} {proximityDescription} {usersResidence} {issueClosing}',
            '{damageAdjective} {issueType} {proximity} {proximityDescription} {streetNameOne} {issueClosing}',
            '{damageAdjective} {issueType} {proximity} {proximityDescription} {streetNameOne} and {streetNameTwo} {issueClosing}',
            '{issueOpening} {propertyType}  {proximity} {streetNameOne}',
            '{issueOpening} {propertyType}  {proximityDescription} {proximity} {address}',
            '{issueOpening} {propertyType} {issueClosing}',
            'i need a {propertyType} fixed',
            '{issueOpening} {propertyType} {proximity} {address} {issueClosing}',
            '{propertyType} {proximity} {address}',
            'stoplight {damageType} on {address}',
            '{issueType}',
            'How do I report property damage',
            '{propertyType} {issueClosing} {proximityDescription}',
            '{propertyType} {issueClosing}',
            'the {propertyType} {proximity} {usersResidence} has been',
            'I want to make a complaint about {propertyType}',
            'I want to report a concern',
            'the {propertyType} is',
            'Request for {propertyType}',
            '{propertyType} request',
            'get {propertyType}',
            'Additional signage',
            'Striping',
            'Road surface marking',
            'additional signage',
            'striping',
            'road surface markings',
            'manhole',
            'manhole cover',
            'get a {propertyType}',
            'request for {propertyType}',
            'request for a {propertyType}',
            'request a {propertyType}',
            '{propertyType} on my road',
            '{damageType} {proximity} {propertyType}',
            '{propertyType} repair',
            'accessibility ramp repair',
            'alley way',
            'disabled parking sign',
            '{propertyType} outage',
            'new {propertyType}',
            'new streetlight',
            '{propertyType} tree trimming',
            'pave',
            'repave',
            'asphalt',
            'The only {propertyType} on my block is {damageType}',
            '{propertyType} turned the wrong way',
            'A car knocked down a {propertyType} {proximity} {proximityDescription} {address}',
            '{proximity} the {address} there is a very dangerous hole',
            '{propertyType} {damageType} at {address}',
            '{propertyType} {proximity} at {address}',
            'Street light {damageType} at one one two two N Robertson',
            '{propertyType}  at one one two two N Robertson',
            '{propertyType}  at {address}',
            'cable malfunction',
            'cable broke',
            'mattress',
            'cable',
            'litter',
            '{propertyType}',
            'man hole',
            'rough surface',
            'debris',
            'rough patch',
            'mattress issue',
            'manhole issue',
            'road surface marking',
            '{damageType} {propertyType}',
            '{issueType} {damageType}',
            '{propertyType} {damageType} at {streetNameOne} and {streetNameTwo}',
            '{propertyType} {damageType} {duration} at {streetNameOne} and {streetNameTwo}',
            '{propertyType} {damageType} {duration} at {address}',
            '{propertyType} {damageType}',
            '{issueOpening} {damageType} {propertyType}'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the public property issue"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Let me summarize this conversation quickly: You've reported an public property issue on {address}. Is that correct?"
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'what is your address?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'PublicPropertyType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'propertyType',
                maxAttempts: 2,
                ellicitedMessage: 'What type of public property is damaged?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'IssuTypeDamageProperty',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'issueType',
                maxAttempts: 2,
                ellicitedMessage: 'What is the type of issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'PublicDamageType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 8,
                name: 'damageType',
                maxAttempts: 2,
                ellicitedMessage: 'How is it damaged?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'DamageAdjective',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 9,
                name: 'damageAdjective',
                maxAttempts: 2,
                ellicitedMessage: 'How bad is the damage?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'DurationOfTime',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 10,
                name: 'duration',
                maxAttempts: 2,
                ellicitedMessage: 'For how long has this been an issue?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'IssueClosing',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 11,
                name: 'issueClosing',
                maxAttempts: 2,
                ellicitedMessage: "What's the issue?",
                obfuscationSetting: 'None'
            },
            {
                slotType: 'IssueOpening',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 12,
                name: 'issueOpening',
                maxAttempts: 2,
                ellicitedMessage: "What's the issue?",
                obfuscationSetting: 'None'
            },
            {
                slotType: 'Proximity',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 13,
                name: 'proximity',
                maxAttempts: 2,
                ellicitedMessage: 'Where is the issue?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'ProximityDescription',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 14,
                name: 'proximityDescription',
                maxAttempts: 2,
                ellicitedMessage: 'Near what street?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 15,
                name: 'streetNameOne',
                maxAttempts: 2,
                ellicitedMessage: 'What street is the damage on?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 16,
                name: 'streetNameTwo',
                maxAttempts: 2,
                ellicitedMessage: 'What is the cross street?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'UsersResidence',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 17,
                name: 'usersResidence',
                maxAttempts: 2,
                ellicitedMessage: 'Where is this close to?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_iss_yard_upkeep_intent',
        utterances: [
            "My neighbor's {yard_item} is completely overgrown",
            'My neighbor needs to cut his {yard_item}',
            'my neighbors {yard_item} is overgrown',
            'Neighbors {yard_item} needs mowing {proximityDescription} {proximity} {address}',
            'The {yard_item} needs to be mowed {proximityDescription} {proximity} {address}',
            'overgrown {yard_item}',
            'overgrown {yard_item} in neighbourhood',
            '{yard_item}',
            'the {yard_item} next door is too high',
            'dead {yard_item}',
            'fallen {yard_item}',
            '{yard_item} {proximity} yard',
            'there is an {yard_item} in the front yard of {address}',
            'the {yard_item} is green {proximity} {address}',
            'there are {yard_item} {proximityDescription} the property {proximity} {address}',
            'I want to report a {yard_item}',
            'blighted property',
            'property maintanence',
            'property maintenance',
            'property next to me is in neglect',
            'trash buildup',
            'needs {rightOfWayIssue}',
            '{rightOfWayIssue}',
            'need {rightOfWayIssue} at my yard',
            'need to {rightOfWayIssue}',
            '{yardWaste}',
            'I want to report a {yardWaste}',
            '{yardWaste} pickup'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll report the yard issue at {address} right away."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Let me summarize this conversation quickly: You've reported a yard issue on {address}. Is that correct?"
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: 'What is the address?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'citibot_yes_no',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'isPrivateProperty',
                maxAttempts: 2,
                ellicitedMessage: 'Is the issue located on private property?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'rightOfWay',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'rightOfWayIssue',
                maxAttempts: 2,
                ellicitedMessage: 'What type of assistance will it require? eg. Litter removal, mowing, trimming',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'cb_yard_nouns_slot',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 8,
                name: 'yard_item',
                maxAttempts: 1,
                ellicitedMessage: 'What is the specific item in the yard that is causing the issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'yardWaste',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 9,
                name: 'yardWaste',
                maxAttempts: 2,
                ellicitedMessage: 'What type of yard waste it is ?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'Proximity',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 10,
                name: 'proximity',
                maxAttempts: 2,
                ellicitedMessage: 'Where is the issue?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'ProximityDescription',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 11,
                name: 'proximityDescription',
                maxAttempts: 2,
                ellicitedMessage: 'Near what street?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_iss_vehicle_intent',
        utterances: [
            '{vehicleIssue} {vehicleType}',
            '{vehicleIssue} vehicle {proximity} {address}',
            '{vehicleIssue} vehicle',
            '{vehicleIssue}',
            '{vehicleIssue} in yard',
            '{vehicleType} {proximity} {address}',
            '{issueOpening} {vehicleType} {proximity} {address}',
            '{vehicleType}',
            '{issueOpening} {vehicleIssue} {vehicleType} {proximity} highway',
            '{issueOpening} {vehicleIssue} {vehicleType} {proximity} {address}',
            'vehicle in driveway at {address} has {vehicleIssue}',
            'vehicle blocking driveway',
            'Vehicle at {address} blocking active parking lot',
            'Abandon vehicles hampering turning traffic on {address}',
            'Abandoned cars in driveway',
            'Can you tell me how to report an abandoned vehicle'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the vehicle issue at {address} "
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the vehicle issue'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'vehicleMake',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'vehicle_make',
                maxAttempts: 2,
                ellicitedMessage: 'What is the make of the vehicle (Ford, Cheverolet, Honda, etc)?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'vehicleColor',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'vehicle_color',
                maxAttempts: 2,
                ellicitedMessage: 'What color is the vehicle?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'vehicleType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'vehicleType',
                maxAttempts: 2,
                ellicitedMessage: 'What kind of vehicle is it (car, truck, sedan, suv)?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'citibot_yes_no',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 8,
                name: 'blockingDriveway',
                maxAttempts: 2,
                ellicitedMessage: 'Is the vehicle blocking a driveway?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 9,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'What is the address of the vehicle issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'IssueOpening',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 10,
                name: 'issueOpening',
                maxAttempts: 2,
                ellicitedMessage: 'n/a',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'Proximity',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 11,
                name: 'proximity',
                maxAttempts: 2,
                ellicitedMessage: 'Where is the issue?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'ProximityDescription',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 12,
                name: 'proximityDescription',
                maxAttempts: 2,
                ellicitedMessage: 'Near what street?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'vehicleIssue',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 13,
                name: 'vehicleIssue',
                maxAttempts: 2,
                ellicitedMessage: 'What is the issue?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_iss_sewage_intent',
        utterances: [
            'The sewer is not draining at {general_loc_slot}',
            'The sewer is not draining on {streetNameOne}',
            'sewage is coming out of the sewer on {streetNameOne}',
            'the street sewage is getting bad on {streetNameOne}',
            'the sewage smell is bad on {streetNameOne}',
            'street sewage on {streetNameOne} in front of {general_loc_slot}',
            'sewage is coming out of the ground',
            'sewage',
            'my water has been shut off',
            'There is some nasty smelling water in the street',
            'stormdrain',
            'clogged stormdrain',
            'clogged sewer',
            'Stormwater drain clogged',
            'stormwater drain backed up',
            'backed up stormwater drain',
            'The storm drain in front of {general_loc_slot} needs repairs',
            'drainage issue',
            'drainage',
            'drainage issues'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank, I'll report the sewage issue on {address} right away."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Let me summarize this conversation quickly: You've reported a sewage issue on {address}. Is that correct?"
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'What is the address of the sewage issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.CivicStructure',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 6,
                name: 'general_loc_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What is a general structure, building, or landmark closest to the sewer issue?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'SewageRequestType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 7,
                name: 'sewageRequestType',
                maxAttempts: 2,
                ellicitedMessage: 'Please choose the sewage issue type',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 8,
                name: 'streetNameOne',
                maxAttempts: 1,
                ellicitedMessage: 'What is the street or intersection that the sewer is on?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 9,
                name: 'streetNameTwo',
                maxAttempts: 2,
                ellicitedMessage: 'What is the nearest cross street?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_report_act_of_kindness',
        utterances: ['act of kindness', 'kind act'],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Thank you, We have noted the act of kindness at {address}'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the act of kindness at {address}'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'Where did this happen?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'kindness_description',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'kindness_description',
                maxAttempts: 2,
                ellicitedMessage: 'Could you describe the act?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'IssueOpening',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 7,
                name: 'issueOpening',
                maxAttempts: 2,
                ellicitedMessage: 'What is the issue?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'Proximity',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 8,
                name: 'proximity',
                maxAttempts: 2,
                ellicitedMessage: 'Where was this?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'ProximityDescription',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 9,
                name: 'proximityDescription',
                maxAttempts: 2,
                ellicitedMessage: 'What was the cross street?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'requestintent',
        utterances: [
            'i want to request a {requestSlot}',
            'request a {requestSlot}',
            'want {requestSlot}',
            'ask for {requestSlot}',
            'submit a request for {requestSlot}',
            'i want to request',
            'i request',
            'i want',
            'I want to request {requestSlot}',
            'I have a request for {requestSlot}',
            'I would like to request a {requestSlot}',
            'request {requestSlot}',
            'i need a {requestSlot}'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, we'll report your {requestSlot} request right away."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Let me summarize this quickly: You are requesting service at {address}. Is that correct?'
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'What is the address for the service request?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'requestType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'requestSlot',
                maxAttempts: 1,
                ellicitedMessage: 'What do you want to request?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'FW_register_name',
        utterances: [
            'my name is {usersName}',
            'change my name to {usersName}',
            'change my name',
            'register my name',
            'register my name as {usersName}',
            'register name',
            'from now on call me {usersName}',
            "I'd like to be called {usersName}"
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Thank you, We have registered your name.'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm your name.'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 1,
                name: 'usersName',
                maxAttempts: 2,
                ellicitedMessage: "What's your first name?",
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_iss_water_issue_intent',
        utterances: [
            'issue related to water',
            'water issue',
            'water meter issue',
            'water issue at {address}',
            'water meter issue at {address}',
            'i need to report issue related to water',
            'report a water issue',
            'at {address} there is a water issue',
            'water meter not working',
            'water meter turned off',
            'water meter broken',
            'broken water meter',
            'water meter stopped',
            'there is water issue {proximity} {address}',
            'water meter not working {proximity} {address}',
            '{waterIssue}',
            'water meter',
            'water utility',
            'water quality',
            'need to report {waterIssue}',
            '{waterIssue} problem',
            '{waterIssue} {damageTypeWater}',
            'broken water meter box',
            'broken water box',
            'broken water meter lid',
            'broken water lid',
            'meter box'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the water issue at {address}, right away"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the aforementioned issue'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'what is the address of the issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'waterIssueType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'waterIssue',
                maxAttempts: 2,
                ellicitedMessage: 'What type of assistance do you require, eg. Water Meter, Hydrant?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'DamageTypeWater',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'damageTypeWater',
                maxAttempts: 2,
                ellicitedMessage: 'Can you please describe damage? eg. broken, stopped, not working.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'Proximity',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 8,
                name: 'proximity',
                maxAttempts: 2,
                ellicitedMessage: 'proximity',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_iss_hazardous_materials_intent',
        utterances: [
            '{materialType} spill',
            '{materialType} {proximityDesc}',
            '{issueOpening} {materialType} {proximityDesc}',
            'hazardous materials',
            '{issueOpening} {materialType} {address}',
            '{issueOpening} {materialType} {proximityDesc} {address}',
            '{issueOpening} {materialType} {proximity} {address}',
            'dumping {materialType}',
            '{materialType}'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the hazardous materials issue at {address}"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm hazardous materials issue at {address} '
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'hazard_material_type',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'materialType',
                maxAttempts: 2,
                ellicitedMessage: 'What type of hazardous material are you reporting? (paint, oil, etc)',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'What is the address?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'Proximity',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 8,
                name: 'proximity',
                maxAttempts: 2,
                ellicitedMessage: 'n/a',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'ProximityDescription',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 9,
                name: 'proximityDesc',
                maxAttempts: 2,
                ellicitedMessage: 'n/a',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'IssueOpening',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 10,
                name: 'issueOpening',
                maxAttempts: 2,
                ellicitedMessage: 'n/a',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_smalltalk_intent',
        utterances: [
            'how is {smalltalk_topic} today',
            'what is {smalltalk_topic} like',
            "what's going on with {smalltalk_topic}",
            "what's up with the {smalltalk_topic} today"
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Unfortunately, I'm not really able to answer that question. But, I can help you search on city website services for an answer or help you make a request from them. Would you like to try one of those? You can simply start describing an issue or type your question here."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the smal talk issue'
                }
            ]
        },
        slots: [
            {
                slotType: 'cb_smalltalk_topic',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 1,
                name: 'smalltalk_topic',
                maxAttempts: 2,
                ellicitedMessage: 'topic',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_req_claim_intent',
        utterances: [
            'the snow plow damaged my {damaged_property_slot} at {address}',
            'could you fix or replace my {damaged_property_slot} at {address}',
            'the street sweeper hit my {damaged_property_slot} at {address}',
            'the snow plow hit it',
            '{damaged_property_slot} is {claim_issue}',
            'my {damaged_property_slot} is out',
            'no {damaged_property_slot}',
            'I have no {damaged_property_slot} in my apartment',
            '{damaged_property_slot} at my apartment has large {claim_issue} in it',
            'There is a {claim_issue} in {damaged_property_slot} of my apartment at {address}',
            'My apartment building at {address} has a large {claim_issue} in {damaged_property_slot}'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, we'll report your damaged property claim on {address} to the appropriate department."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Let me quickly summarize: You've reported a damaged property claim on {address}. Is that correct?"
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'cb_damaged_property_slot',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'damaged_property_slot',
                maxAttempts: 1,
                ellicitedMessage: 'What kind of residential property was damaged?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: 'What is the address where this happened?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'claim_issue',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 7,
                name: 'claim_issue',
                maxAttempts: 2,
                ellicitedMessage: 'What is the issue?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_iss_noise_intent',
        utterances: [
            '{local_biz_type_slot} makes too much noise at night',
            "neighbor's dog does not stop barking all night",
            '{local_biz_slot} makes too much noise at night',
            'loud party at {address}',
            'it is too noisy at {address}',
            'my neighbors are having a loud party',
            'my neighbors are too loud',
            'my neighbors are being loud',
            'my neighbors dog is barking so loud tonight',
            'my neighbors music is too loud',
            'noise issue',
            'barking {animalType}',
            'report a barking {animalType}',
            'fireworks',
            'The fireworks are loud',
            'someone is shooting off fireworks in my neighborhood',
            'the neighbors fireworks are too loud',
            'extremely loud fireworks',
            'noise complaint',
            'Noise ordinance',
            'Construction noise',
            'loud construction',
            'Noise',
            'Loud music from bar',
            'Amplified music',
            'louder',
            'Continuous noise caused by bar downstairs',
            'rooster crowing',
            'chicken noise',
            'loud rooster',
            'loud chickens',
            'there is construction noise',
            'Insanely loud',
            'amplified',
            'live band in their outdoor courtyard on Royal Street',
            "Someone is playing there loud speakers on the streets and it's vibrating my whole house",
            'Who do I call to report  a noise ordinance',
            'barking {animalType} next'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll report the noise issues at {address} right away."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Let me summarize this conversation quickly: You've reported a noise issue by {address}. Is that correct?"
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: 'What is the address of the noise issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.Animal',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 6,
                name: 'animalType',
                maxAttempts: 2,
                ellicitedMessage: 'What type of animal?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.LocalBusiness',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 7,
                name: 'local_biz_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What is the name of the local business causing the noise?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.LocalBusinessType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 8,
                name: 'local_biz_type_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What type of business is it?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_emergency_intent',
        utterances: [
            'emergency',
            '{emergency_type} emergency',
            'Suspicious kids by the park',
            'I need the police',
            'there is smoke coming from a building',
            'there is a fire',
            'fire',
            'I need the fire department',
            'contact the police',
            'there is a shooting',
            'shooting',
            'I need an ambulance',
            'someone has been shot',
            'police',
            'nine one one',
            'crime',
            'emergency management',
            'Dumpster on Fire',
            'car accident',
            'there is been a car accident',
            'robbery',
            'robbery in progress',
            'I just felt an earthquake what should I do',
            'I felt an earthquake',
            'There is an earthquake',
            'What do I do if there is an earthquake',
            'there has been an accident',
            'car accident on street'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'For emergencies, please call 911'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the Emergency Intent?'
                }
            ]
        },
        slots: [
            {
                slotType: 'emergency_type',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 1,
                name: 'emergency_type',
                maxAttempts: 2,
                ellicitedMessage: 'what type of emergency?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'intercept_cs_bike_lane_intent',
        utterances: ['bike lanes'],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the bike lane issue"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the bike lane issue'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: false,
        protected: true
    },
    {
        name: 'cb_iss_tree_intent',
        utterances: [
            'a tree has fallen onto the street at {address}',
            'tree has fallen across {streetNameOne}',
            'traffic is backed up on {streetNameOne} because of a fallen tree',
            '{issueOpening} tree down',
            'downed tree',
            'tree in creek',
            '{issueOpening} tree in the middle of the road',
            'Tree limbs hang out into the street partially blocking the road at {address}',
            'Tree limbs are too low at {address}',
            'fallen tree',
            'tree trim',
            'tree trim needed',
            'request a tree trim',
            'request to trim trees',
            'need to trim trees'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll report the tree issue on {address} to the appropriate department now."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Let me summarize this conversation quickly: You've reported a tree issue on {address}. Is that correct?"
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: 'What is the address of the tree issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.CivicStructure',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 6,
                name: 'general_loc_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What is a building or landmark closest to the fallen tree or branch?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'IssueOpening',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 7,
                name: 'issueOpening',
                maxAttempts: 2,
                ellicitedMessage: 'n/a',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 4,
                name: 'streetNameOne',
                maxAttempts: 2,
                ellicitedMessage: 'What are the cross streets closest to the fallen tree or branch?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 5,
                name: 'streetNameTwo',
                maxAttempts: 2,
                ellicitedMessage: 'What is the nearest cross street?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'FW_register_email',
        utterances: [
            'change my email',
            'change my email to {email}',
            'register email',
            'register my email as {email}',
            'register my email'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Thank you, We have updated your registered Email'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm your mail address'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 1,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'What is your email address?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_ongoing_construction_intent',
        utterances: [
            'construction ongoing',
            'ongoing construction',
            'construction has lasted a long time',
            'the construction on {address} has lasted a long time'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the ongoing construction issue at {address} "
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the ongoing construction issue at {address}'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'Where is the issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_req_repair_recycling_bin_intent',
        utterances: [
            'my {recycle_container_type} roll {recycle_container_noun} is broken',
            'my {recycle_container_color} {recycle_container_type} {recycle_container_noun} is broken at {address}',
            'the wheel is missing from my {recycle_container_type} {recycle_container_noun}',
            'the lid on my {recycle_container_type} is broken',
            'please fix my {recycle_container_type} at {address}',
            'my rolling {recycle_container_noun} is broken for {recycle_container_type}',
            'the wheel on my {recycle_container_type} {recycle_container_noun} is broken',
            'my {recycle_container_type} lid has fallen off',
            'my {recycle_container_type} {recycle_container_noun} needs to be replaced',
            'I have a broken {recycle_container_type} {recycle_container_noun}',
            'my {recycle_container_color} {recycle_container_noun} is broken',
            '{recycle_container_type} {recycle_container_noun}',
            'replacement {recycle_container_noun}',
            'I need a new {recycle_container_type} {recycle_container_noun}',
            'requesting new {recycle_container_type} {recycle_container_noun}',
            'my {recycle_container_type} {recycle_container_noun} is broken',
            'my {recycle_container_type} {recycle_container_noun} is damaged',
            '{replacementReason} {recycle_container_type} {recycle_container_noun}'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Thank you, someone will follow up to schedule a repair or replacement of the recycle container at {address} soon.'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to schedule a repair or replacement of the recycle container at {address}'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'What is your address, so we can send a repair or replacement?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'ConfirmCurbside',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'confirmCurbside',
                maxAttempts: 2,
                ellicitedMessage: 'Please confirm. Is the container located curbside or backyard?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'DescribeDamage',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'describeDamage',
                maxAttempts: 2,
                ellicitedMessage: 'If damaged please describe the damage details, otherwise none.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.Color',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 8,
                name: 'recycle_container_color',
                maxAttempts: 2,
                ellicitedMessage: 'What color is it?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'cb_trash_container_noun',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 9,
                name: 'recycle_container_noun',
                maxAttempts: 2,
                ellicitedMessage: 'type of container',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'cb_recycle_synonym_slot',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 10,
                name: 'recycle_container_type',
                maxAttempts: 2,
                ellicitedMessage: 'recycle or recycling',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'ReplacementReason',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 11,
                name: 'replacementReason',
                maxAttempts: 2,
                ellicitedMessage: 'What is the reason for replacement (ie. Damaged, Stolen)?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.LocalBusiness',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 12,
                name: 'location',
                maxAttempts: 2,
                ellicitedMessage: 'Where is the issue?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'LocationType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 13,
                name: 'locationType',
                maxAttempts: 2,
                ellicitedMessage: 'Please confirm by replying with the letter A, B, or C. Is this a:',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        protected: true,
        isSRIntent: true
    },
    {
        name: 'cb_iss_flood_intent',
        utterances: [
            'my house is flooded at {address}',
            'there is a lot of flooding at {general_loc_slot}',
            "you can't drive on {street_slot} because it is flooded",
            'traffic is backed up down {street_slot} because of the flooding',
            'there is high tide flooding on {street_slot}',
            "you can't cross {street_slot} because it is flooded",
            'the flooding is bad on {street_slot}',
            'flooding'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll report the flooding issue at {address} right away."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the flooding issue at {address}'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: 'What is the address closest to the flooded area?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.CivicStructure',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 6,
                name: 'general_loc_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What is a specific building or landmark closest to the flooding?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.StreetAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 7,
                name: 'street_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What is the street or intersection that the flooding is occuring on?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'cb_req_repair_trashcan_intent',
        utterances: [
            'my {trash_container_type} roll {trash_container_noun} is broken',
            'my {trash_container_color} {trash_container_type} {trash_container_noun} is broken at {address}',
            'the wheel is missing from my {trash_container_type} {trash_container_noun}',
            'the lid on my {trash_container_type} is broken',
            'please fix my {trash_container_type} at {address}',
            'my rolling {trash_container_noun} is broken for {trash_container_type}',
            'the wheel on my {trash_container_type} {trash_container_noun} is broken',
            'my {trash_container_type} lid has fallen off',
            'my {trash_container_type} {trash_container_noun} needs to be replaced',
            'I have a broken {trash_container_type} {trash_container_noun}',
            'my {trash_container_color} {trash_container_noun} is broken',
            '{trash_container_type} {trash_container_noun}',
            'replacement {trash_container_noun}',
            'I need a new {trash_container_type} {trash_container_noun}',
            'requesting new {trash_container_type} {trash_container_noun}',
            'i have a damaged {trash_container_noun}',
            'i have a broken {trash_container_noun}',
            'my {trash_container_type} {trash_container_noun} is broken',
            'my {trash_container_type} {trash_container_noun} is damaged',
            '{replacementReason} {trash_container_noun}',
            '{replacementReason} {trash_container_type} {trash_container_noun}'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Thank you, someone will follow up to schedule a trash container repair or replacement at {address} soon.'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the trash container repair or replacement at {address}'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'cb_trash_synonym_slot',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'trash_container_type',
                maxAttempts: 1,
                ellicitedMessage: 'Can you please clarify if this is for your trash, recycling, or yard waste container?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'DescribeDamage',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'describeDamage',
                maxAttempts: 2,
                ellicitedMessage: 'Please describe the damage',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'color_slot_type',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'trash_container_color',
                maxAttempts: 2,
                ellicitedMessage: 'What is the color of the container?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'ConfirmCurbside',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 8,
                name: 'confirmCurbside',
                maxAttempts: 2,
                ellicitedMessage: 'Please confirm. Is the container located curbside or backyard?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'ReplacementReason',
                slotConstraint: 'Required',
                priority: 9,
                name: 'replacementReason',
                maxAttempts: 2,
                ellicitedMessage: 'What is the reason for replacement (ie. Damaged, Stolen)?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 9,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: 'What is your address, so we can send a repair or replacement?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'cb_trash_container_noun',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 10,
                name: 'trash_container_noun',
                maxAttempts: 2,
                ellicitedMessage: 'type of container',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'cb_iss_zoning_intent',
        utterances: [
            'neighbor doing work on house without a permit at {address}',
            "neighbor doesn't have a permit to do construction",
            "there's too much construction at {address}",
            "nighbor's house is not zoned to be a {local_biz_type_slot}",
            'my neighbor has done construction without a permit',
            'my neighbor has built a {zoning_violation_type} without a permit',
            'illegal {zoning_violation_type}',
            'no permit'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll report the potential zoning issue at {address} right away."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Let me summarize this conversation quickly: You've reported a potential zoning issue on {address}. Is that correct?"
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: 'What is the address of the potential zoning issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.LocalBusinessType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 6,
                name: 'local_biz_type_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What kind of activity is going on at the building? ',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'cb_zoning_violation_type_slot',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 7,
                name: 'zoning_violation_type',
                maxAttempts: 2,
                ellicitedMessage: 'What kind of violation?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'cb_iss_outside_storage_intent',
        utterances: ['outside storage', 'storage issue', 'neighbor is storing junk'],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the storage issue at {address}"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the storage issue at {address}'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'What is the address of the storage issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'cb_missed_trash_pickup',
        utterances: [
            'My {trash_phrase} has not been picked up',
            'please empty my {trash_phrase}',
            'has not been picked up in {time_since_last_pickup}',
            'empty my {trash_phrase} at {address}',
            'pick up my {trash_phrase} at {address}',
            'pick up my {trash_phrase} at my house',
            'report my {trash_phrase} was not picked up',
            'please come to {address} to pick it up',
            'pick it up at {address}',
            'report a missed {trash_phrase} pickup',
            'I would like to request a {trash_phrase} pickup',
            'Please pick up my {trash_phrase} at {address}',
            'missed my {trash_phrase} pickup. I live at i live at {address}',
            'I have {trash_phrase} to be picked up in front of my house',
            'please pick up the {trash_phrase} on my street at {address}',
            "you haven't picked it up in {time_since_last_pickup}",
            'When can someone pick up the {trash_phrase} in front of my house at {address}',
            'empty my {trash_phrase} can at {address}',
            '{trash_phrase} pickup',
            'my {trash_phrase} was missed',
            '{trash_phrase} missed',
            'missed {trash_phrase}',
            '{trash_phrase} pick up',
            'Do you offer {trash_phrase}',
            'missed {trash_phrase} collection',
            'my {trash_phrase} is still sitting outside',
            'my {trash_phrase} is still on the curb',
            'no one picked up my {trash_phrase}',
            'missed {trash_phrase} pickup',
            'missed {trash_phrase} pick up',
            'my {trash_phrase} pickup was missed',
            'my {trash_phrase} pick up was missed',
            '{bulkyItems}',
            '{bulkyItems} pickup',
            'needs {bulkyItems} pickup'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be report trash pickup at {address}"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Do you want to go ahead and raise request for trash pickup at {address} ?'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: 'What is the address for pickup?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'cb_trash_synonym_slot',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 4,
                name: 'trash_phrase',
                maxAttempts: 1,
                ellicitedMessage: 'Could you clarify if this is for a trash pickup or recycling pickup, or other?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'BulkItemYesNo',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'bulkItemConfirmation',
                maxAttempts: 2,
                ellicitedMessage: 'Please answer Yes or No. Is this a bulk item?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'bulkyItems',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 6,
                name: 'bulkyItems',
                maxAttempts: 2,
                ellicitedMessage: 'e.g. What city?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'ScheduledDay',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'scheduledDay',
                maxAttempts: 2,
                ellicitedMessage: 'What day of the week is your scheduled collection day?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.DURATION',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 8,
                name: 'time_since_last_pickup',
                maxAttempts: 2,
                ellicitedMessage: 'Also, when is the last time it was picked up?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'cb_who_is_this',
        utterances: [
            'is this citibot',
            'who is this',
            'is this the city chat service',
            'who are you',
            'are you citibot',
            'are you real',
            'Help'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Hello, this is Citibot. Here in this chat you can (1) report an issue to the city, like a pothole or missed trash pickup; (2) ask a question; or (3) send a message to city staff. What would you like to do?'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Do You want to know about us?'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: false,
        protected: true
    },
    {
        name: 'cb_home_business_intent',
        utterances: [
            'illegal business next door',
            'my neighbor is selling',
            'business out of home',
            'my neighbor is selling a service out of his home',
            'my neighbor is selling services'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the business out of home issue at {address} "
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the business out of home at {address} issue'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'address',
                maxAttempts: 2,
                ellicitedMessage: 'What is the address of the issue?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'cb_help_fallback_intent',
        utterances: ['wait how do I use this', 'help'],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "We're here to help. If you want to report an issue, you can start giving a short description of the problem and where it is. Or, if you have a question you can also ask it here. Finally, if you have another type of message for city staff, you can say something like, 'I want to leave message'."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Sorry, are you asking any help from us?'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'hellointent',
        utterances: [
            'Hello',
            'Hi',
            'Hi there',
            'Hey',
            "How's it going",
            'hello citibot',
            'hi citibot',
            'hi there citibot',
            'hey citibot',
            'hows it going citibot',
            'hey citibot hows it going',
            'hola',
            'good morning',
            'help with ida',
            'hurricane ida',
            'greeting'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "We're here to help. If you want to report an issue, you can start giving a short description of the problem and where it is. Or, if you have a question you can also ask it here. Finally, if you have another type of message for city staff, you can say something like, 'I want to leave message'."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot, lex_constants_data_1.LexBotType.SearchAndMessageBot],
        isSRIntent: false,
        protected: true
    },
    {
        name: 'cb_req_remove_snow_intent',
        utterances: [
            'the snow is blocking my house at {address}',
            'please remove the snow at {address}',
            'snow is blocking my driveway at {address}',
            'please push the snow away from my driveway at {address}',
            'snow removal',
            'snow plow',
            'I need a snow plow at {address}',
            'Ice removal',
            'I need ice removed at {address}'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, we'll schedule a snow and ice removal at {address}. for you."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Let me summarize this quickly: You are requesting snow removal on {address}. Is that correct?'
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 1,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: "What's the address that needs snow removal?",
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'cb_iss_roadkill_intent',
        utterances: [
            'there is a dead {animal_slot} at {address}',
            'a dead {animal_slot} is in front of {address}',
            'please pick up the dead {animal_slot} on {streetNameOne}',
            'roadkill',
            'How do I request pick up of a dead animal on the highway',
            'dead animal pickup',
            'dead animal'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll report the deceased animal at {address} right away."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Let me summarize this conversation quickly: You've reported a deceased animal on {address}. Is that correct?"
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.Animal',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'animal_slot',
                maxAttempts: 1,
                ellicitedMessage: 'Could you describe the animal so the team knows the size for cleanup?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'citibot_yes_no',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'animalOnPrivateProperty',
                maxAttempts: 2,
                ellicitedMessage: 'Please answer Yes or No. Is the animal on private property?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AnimalWeight',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'animalWeight',
                maxAttempts: 2,
                ellicitedMessage: 'Does animal weight exceed 100?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 8,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: 'What is the address closest to where you saw this?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'PickupLocation',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 9,
                name: 'pickupLocation',
                maxAttempts: 2,
                ellicitedMessage: 'Describe pick up location (e.g, curb middle of street, intersection, etc.)',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 10,
                name: 'streetNameOne',
                maxAttempts: 2,
                ellicitedMessage: 'What street is this on?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.LocalBusiness',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 11,
                name: 'local_biz_slot',
                maxAttempts: 2,
                ellicitedMessage: "What's the name of the establishment this is by?",
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.LocalBusinessType',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 12,
                name: 'local_biz_type_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What kind of business is this by?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 13,
                name: 'streetNameTwo',
                maxAttempts: 2,
                ellicitedMessage: 'What is the nearest cross street?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'cb_iss_animal_services_intent',
        utterances: [
            'i lost my {animal_type}',
            'I found a stray {animal_type}',
            'lost {animal_type}',
            'stray {animal_type}',
            'I think my {animal_type} has been impounded',
            '{issueOpening} lost {animal_type}',
            '{issueOpening} animal in my neigborhood',
            '{issueOpening} loose {animal_type} in my neigborhood',
            '{issueOpening} loose {animal_type}',
            '{issueOpening} {animal_type} loose at {address}',
            '{issueOpening} {animal_type} loose on {address}',
            'animal control',
            'my {animal_type} is missing',
            'I saw a {animal_type}',
            '{issueOpening} {animal_type} {proximity} {address}',
            'sick {animal_type}',
            '{issueOpening} {animal_type} coming from {address}',
            '{issueOpening} {animal_type}',
            'i saw a {animal_type} this morning {proximity} {address}',
            'catch a dog',
            'animal service',
            '{issueOpening} barking {animal_type}'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, we'll report this to animal services right away."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the animal service issue at {address}.'
                }
            ]
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.Animal',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'animal_type',
                maxAttempts: 1,
                ellicitedMessage: 'What type of animal is it?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: 'What is your address, so we can contact the nearest animal services?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'IssueOpening',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 7,
                name: 'issueOpening',
                maxAttempts: 2,
                ellicitedMessage: 'n/a',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'Proximity',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 8,
                name: 'proximity',
                maxAttempts: 2,
                ellicitedMessage: 'n/a',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'thank_you_intent',
        utterances: [
            'thanks',
            'thank you',
            'thanks a lot',
            'Much appreciated',
            'Gracias',
            'okay thanks',
            'This is awesome',
            'Great',
            'awesome'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Thank you for using Citibot. Have a great day!'
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot, lex_constants_data_1.LexBotType.SearchAndMessageBot],
        isSRIntent: false,
        protected: true
    },
    {
        name: 'cb_iss_graffiti_intent',
        utterances: [
            'someone has painted graffiti on the wall',
            'someone has painted graffiti all over {general_loc_slot}',
            'there is graffiti at {address}',
            'there is graffiti on {general_loc_slot} at {address}',
            'there is graffiti on my house at {address}',
            'please paint over the graffiti at {general_loc_slot}',
            'graffiti',
            'please paint over the graffiti on {streetNameOne} and {streetNameTwo}',
            'graffiti on {streetNameOne} and {streetNameTwo}',
            'What can be done about graffiti'
        ],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll report the graffiti right away."
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Let me summarize this conversation quickly: You've reported graffiti by {address}. Is that correct?"
                }
            ],
            maxAttempts: 3
        },
        slots: [
            {
                slotType: 'AMAZON.AlphaNumeric',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 2,
                name: 'name',
                maxAttempts: 1,
                ellicitedMessage: 'Ok! We need to gather a little more information about your request. What is your name?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PhoneNumber',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 3,
                name: 'phone_number',
                maxAttempts: 1,
                ellicitedMessage: 'What is your mobile number?  We need this only to follow up with you.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.EmailAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 4,
                name: 'email',
                maxAttempts: 2,
                ellicitedMessage: 'Please provide an email address should we have any follow up questions.',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.CivicStructure',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 5,
                name: 'general_loc_slot',
                maxAttempts: 2,
                ellicitedMessage: 'What is the general building, structure, or landmark?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'isGangGraffiti',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 6,
                name: 'graffitiGang',
                maxAttempts: 2,
                ellicitedMessage: 'Is the graffiti gang related?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'issueInPark',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 7,
                name: 'issueInPark',
                maxAttempts: 2,
                ellicitedMessage: 'Is the graffiti located in a park?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'citibot_yes_no',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 8,
                name: 'propertyOwner',
                maxAttempts: 2,
                ellicitedMessage: 'Are you the owner of this property',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.PostalAddress',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Required,
                priority: 9,
                name: 'address',
                maxAttempts: 1,
                ellicitedMessage: 'What is the address closest to the graffiti?',
                obfuscationSetting: lex_constants_data_1.ObfuscationSettingsOptionEnum.None
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 10,
                name: 'streetNameOne',
                maxAttempts: 2,
                ellicitedMessage: 'What street is the graffiti on?',
                obfuscationSetting: 'None'
            },
            {
                slotType: 'AMAZON.SearchQuery',
                slotConstraint: lex_constants_data_1.SlotConstraintOptionEnum.Optional,
                priority: 11,
                name: 'streetNameTwo',
                maxAttempts: 2,
                ellicitedMessage: 'What is the nearest cross street to the graffiti?',
                obfuscationSetting: 'None'
            }
        ],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: true,
        protected: true
    },
    {
        name: 'intercept_fv_curbside_code_violation',
        utterances: ['curbside violation'],
        conclusionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: "Thank you, I'll be reporting the curbside violation issue"
                }
            ]
        },
        rejectionStatement: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Okay, your request has been cancelled.'
                }
            ]
        },
        confirmationPrompt: {
            messages: [
                {
                    contentType: 'PlainText',
                    content: 'Please provide yes or no to confirm the curbside violation issue'
                }
            ]
        },
        slots: [],
        acceptedBots: [lex_constants_data_1.LexBotType.LegacyBot],
        isSRIntent: false,
        protected: true
    }
];
